export default __webpack_public_path__ + "../staticImages/home-category-red.svg";